import React from 'react';
import { RSelect, Button } from '../../../../components/Component';
import SelectLeadSource from '../../../../components/SelectLeadSource'; // Assuming this path is correct
import { newRoles } from '../../../../utils/envConfig'; // For role checks if needed directly

const LeadsListBulkActions = ({
    selectedItemsCount,
    authuser,
    agentOptions,
    // leadSourceOptions, // This seems to be fetched internally by SelectLeadSource or passed to it
    bulkActionOptions,
    currentBulkAction, // new prop to control which action is selected
    onBulkActionChange, // callback for RSelect change
    selectedAgentForBulk,
    onAgentChangeForBulk,
    selectedLeadSourceForBulk,
    onLeadSourceChangeForBulk,
    reAssignmentReasonForBulk,
    onReAssignmentReasonChangeForBulk,
    onBulkAssign,
    onTriggerBulkReturn,
    saveLoading,
}) => {
    const filteredBulkActionOptions = bulkActionOptions.filter((option) =>
        option.roles.some((allowedRole) => authuser?.roles?.includes(allowedRole))
    );
    const isChannelPartnerManager = authuser?.role === newRoles?.ChannelPartnerManager;

    return (
        <div className="form-inline flex-nowrap gx-3 gy-3 mt-2">
            <div className="form-wrap">
                {selectedItemsCount > 0 && (
                    <RSelect
                        options={filteredBulkActionOptions}
                        className="w-200px"
                        placeholder={`Bulk Action (${selectedItemsCount} selected)`}
                        onChange={(option) => {
                            onBulkActionChange(option.value);
                        }}
                        value={filteredBulkActionOptions.find(opt => opt.value === currentBulkAction) || null}
                    />
                )}
            </div>

            {selectedItemsCount > 0 && currentBulkAction === 'assign' && (
                <>
                    <div>
                        <div className="form-wrap" style={{ minWidth: '200px', marginBottom: isChannelPartnerManager ? '0px' : '10px' }}>
                            <RSelect
                                options={agentOptions}
                                placeholder={selectedAgentForBulk?.label ? selectedAgentForBulk.label : 'Select Agent'}
                                value={selectedAgentForBulk}
                                onChange={(selectedOption) => onAgentChangeForBulk(selectedOption)}
                            />
                        </div>
                        {!isChannelPartnerManager && <SelectLeadSource
                            value={selectedLeadSourceForBulk}
                            onChange={(val) => {
                                onLeadSourceChangeForBulk(val);
                            }}
                        />}
                    </div>
                    <div style={{ minWidth: '400px' }}>
                        <textarea
                            className="form-control single-line-textarea"
                            placeholder="Write the reason for the reassignment"
                            value={reAssignmentReasonForBulk}
                            onChange={(e) => onReAssignmentReasonChangeForBulk(e.target.value)}
                        />
                    </div>
                    <div className="btn-wrap">
                        <Button
                            onClick={(event) => {
                                onBulkAssign(event);
                            }}
                            disabled={saveLoading || selectedItemsCount === 0}
                            color={'primary'}
                        >
                            {saveLoading ? 'Updating...' : `Apply on ${selectedItemsCount} selected`}
                        </Button>
                    </div>
                </>
            )}

            {selectedItemsCount > 0 && currentBulkAction === 'return' && (
                <div className="btn-wrap mt-2">
                    <Button
                        onClick={() => {
                            onTriggerBulkReturn();
                        }}
                        disabled={saveLoading || selectedItemsCount === 0}
                    >
                        {saveLoading ? 'Returning...' : 'Apply'}
                    </Button>
                    <span className="cursor-default ms-2 text-soft fs-12px">
                        {`${selectedItemsCount} Selected`}
                    </span>
                </div>
            )}
        </div>
    );
};

export default LeadsListBulkActions;